<template>
  <div id="completedDialog">
    <el-dialog
      :visible.sync="showLocal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :width="dialogWidth"
      @close="toggleClaim"
    >
      <div class="completeTitle">
        {{ $t('component.complete.title') }}
      </div>

      <div class="completeSubtitle">
        {{ $t('component.complete.youHaveCompleted') }}
      </div>

      <div class="completeContent">
        {{ $t('component.complete.completeContent') }}
      </div>

      <div class="completeActions">
        <el-button
          type="primary"
          round
          :loading="processLoading"
          @click="toggleClaim(true)"
        >
          {{ $t('component.complete.claimCertificate') }}
        </el-button>
      </div>
    </el-dialog>

    <canvas
      v-if="showLocal"
      id="dialogCanvas"
    ></canvas>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import api from '@/api';
import dialog from '@/mixins/dialog';
import qs from 'qs';

export default {
  name: 'CompletedDialog',

  mixins: [dialog],

  data: () => ({
    processLoading: false,
  }),

  computed: {
    ...mapState({
      engagementUuid: (state) => state.processStatus.process.curr_engagement_uuid,
    }),
  },

  methods: {
    ...mapActions('processStatus', [
      'fetchProcess',
    ]),

    async toggleClaim(tab) {
      // tab : Boolean
      try {
        this.processLoading = true;
        await api.patchEngagement(this.engagementUuid, { status: 'completed' });

        if (tab) {
          const params = { service: process.env.VUE_APP_SERVICE };
          window.open(
            `${process.env.VUE_APP_PDF_REPORT_CLIENT}/certification/${this.engagementUuid}${qs.stringify(params, { addQueryPrefix: true })}`,
            '_blank',
          );
        }
        this.fetchProcess();
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.processLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #completedDialog {
    .completeTitle {
      text-align: center;
      font-size: 26px;
      color: #003865;
      font-weight: bold;
      margin-bottom: 15px;
    }

    .completeSubtitle {
      text-align: center;
      font-size: 18px;
      color: #003865;
      margin: 15px 0;
    }

    .completeContent {
      word-break: break-word;
    }

    .completeActions {
      text-align: center;
      margin-top: 20px;
    }
  }
</style>

<style lang="scss">
  #completedDialog {
    .el-dialog__body {
      padding: 5px 20px 30px;
    }
  }

  #dialogCanvas {
    display: block;
    position: absolute;
    opacity: 0.8;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    z-index: 999999;
  }
</style>
